module.exports = __webpack_public_path__ + "assets/img/y_20.eae937b0.png";